module.exports = __webpack_public_path__ + "static/zmiany-3-da17da6bacb1385b2a1e52b6022f03ce.jpg";